import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=65e75aa4&scoped=true&"
import script from "./Section1.vue?vue&type=script&lang=js&"
export * from "./Section1.vue?vue&type=script&lang=js&"
import style0 from "./Section1.vue?vue&type=style&index=0&id=65e75aa4&lang=scss&scoped=true&"
import style1 from "./Section1.vue?vue&type=style&index=1&id=65e75aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e75aa4",
  null
  
)

export default component.exports